import TranslationsConfigType from './translationType';

const nbTranslations: TranslationsConfigType = {
    tryAgain: 'Prøv igjen',
    showLess: 'Vis mindre',
    showMore: 'Vis mer',
    cancel: 'Avbryt',
    errors: {
        somethingWentWrong: 'Noe gikk galt!',
        ohNo: 'Å nei!',
        oops: 'Oj sann!',
        timeoutMessage: 'Vi beklager, det tok litt lenger tid enn vi hadde tenkt. Du må gjerne prøve igjen',
        defaultMessage: 'Vi beklager, det skjedde en teknisk feil. Vennligst prøv igjen litt senere.',
        signing_done: 'Denne signeringsordren er allerede signert',
        signing_rejected: 'Denne signeringsordren er avvist',
        signrefnotfound: 'Denne signeringsordren er ikke lenger tilgjengelig for signering',
        generic_error: 'Noe gikk galt',
    },
    documentsHeader: 'Oppgaver til gjennomgang',
    task: {
        documentsForSigning: 'Start signering av dokumenter',
        signedDocumentsForDownload: 'Signerte dokumenter til nedlasting',
        deadlinePassedTitle: 'Fristen har gått ut!',
        deadlinePassedMessage:
            'Denne søknaden er dessverre gått ut, fordi fristen for gjennomføring er ute. Ønsker du fortsatt å søke, må du starte en ny søknad.',
        cancelledTitle: 'Kansellert',
        cancelledMessage: 'Denne søknaden har blitt kansellert. Ønsker du fortsatt å søke må du starte en ny søknad',
        rejectedTitle: 'Avvist',
        rejectedMessage: 'Denne søknaden har blitt avvist. Ønsker du fortsatt å søke må du starte en ny søknad',
        tasksTitle: 'Oppgaver',
        attachmentsTitle: 'Vedlegg',
        documentsTitle: 'Dokumenter',
        signedTitle: 'Du har signert',
        signedMessage: 'Du har gjort ditt. Når alle partene er ferdig vil du finne en nedlastbar versjon',
        readyForCancellationTitle: 'Klar for kansellering',
        readyForCancellationMessage:
            'Denne oppgaven er klar for kansellering. Ønsker du fortsatt å søke må du starte en ny søknad',
    },
    taskStatus: {
        deadlinePassed: 'Fristen har gått ut',
        waitingForOtherSignees: 'Venter på andres gjennomgang',
        requiresAction: 'Krever handling',
        rejected: 'Avvist',
        readyForCancellation: 'Klar for kansellering',
        deadlineToday: 'Frist i dag',
        deadline: 'Frist {}',
        signed: 'Signert: {} av {}',
        cancelled: 'Kansellert',
        consentAssignmentSigned: 'Signert',
    },
    recentlyReviewedHeader: 'Sist ferdigstilte oppgaver',
    noDocumentsForReview: 'Ingen oppgaver til gjennomgang',
    noNewlyReviewedTasks: 'Ingen nylig ferdigstilte oppgaver',
    ok: 'Ok',
    consentAssignment: {
        title: 'Samtykkebasert lånesøknad',
        completedTitle: 'Takk for ditt samtykke!',
        bodyText: {
            DEFAULT:
                `I forbindelse med din søknad om lån i {} er ` +
                `du oppført som {} med {}. ` +
                'For at dere skal komme videre i søknadsprosessen trenger vi ' +
                'ditt samtykke til å hente ut din lønns- og skatteinformasjon fra Altinn.',
            KAUSJONIST:
                `{} har oppgitt deg som kausjonist i forbindelse med søknad om lån i {}.` +
                ' For at vi skal kunne behandle søknaden, trenger vi ditt samtykke til at ' +
                'vi henter ut din inntekts- og skatteinfomasjon fra Altinn.',
            HOVEDLAANTAKER:
                `I forbindelse med din søknad om lån i {} er ` +
                `du oppført som {}. ` +
                'For at dere skal komme videre i søknadsprosessen trenger vi ' +
                'ditt samtykke til å hente ut din lønns- og skatteinformasjon fra Altinn.',
            ACCEPTED: 'Samtykket er mottatt og lønns- og skatteinformasjonen din blir hentet fra Skatteetaten.',
        },
        interestedParty: {
            HOVEDLAANTAKER: 'hovedlåntaker',
            MEDLAANTAKER: 'medlåntaker',
            KAUSJONIST: 'kausjonist',
            INNEHAVER: 'innehaver',
            DEFAULT: 'interessent',
        },
    },
    fundingCertificate: { title: 'Finansieringsbevis', description: 'Utløpsdato: {}' },
    antiMoneyLaunderingTask: {
        title: 'Kundeerklæring antihvitvask',
        taskTitle: 'Besvar kundeerklæring',
        ahvTaskCompleted: {
            title: 'Kundeerklæring gjennomført!',
            description: 'Takk for at du har besvart kundeerklæringen.',
        },
        ahvTaskError: {
            title: 'Registering av kundeopplysninger feilet!',
            description: 'Noe gikk dessverre galt med registering av svarene dine, vennligst prøv igjen senere.',
        },
    },
    archive: {
        noArchivedTasks: 'Ingen gjennomgåtte oppgaver',
        title: 'Ferdige oppgaver',
        oldestFirst: 'Eldste først',
        newestFirst: 'Nyeste først',
    },
    sdoHelp: {
        howOpen: 'Hvordan åpner jeg den signerte filen (SDO)?',
        modalBody:
            'En SDO-fil er ikke like lett å åpne som en vanlig PDF. Ønsker du det, kan du bruke en tjeneste fra Nets (BBS) som kalles E-Signing Validator. Der kan du laste opp filen og få bekreftet at den er signert, i tillegg til å åpne dokumentet. Følg lenken nedenfor for å gå til Nets i et nytt vindu.',
        linkText: 'Åpne signerte dokumenter hos Nets',
    },
};

export default nbTranslations;
